"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const urlInput_style_1 = __importDefault(require("./urlInput.style"));
const UrlInput = ({ classes, onLinkInputKeyDown, urlInputChange, handleCollapse, value, validUrl }) => {
    // With the new version of jest, spying on useRef works only
    // if we use React.useRef...
    const inputWrapperRef = react_1.default.useRef(null);
    const handleClick = react_1.useCallback(e => !inputWrapperRef.current.contains(e.target) && handleCollapse(), [handleCollapse]);
    react_1.useEffect(() => {
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [handleClick]);
    const handleKeyPress = event => {
        const hotKeys = {
            27: () => {
                // escape
                handleCollapse();
            }
        };
        if (hotKeys[event.keyCode]) {
            event.preventDefault();
            hotKeys[event.keyCode]();
        }
    };
    const rootProps = {
        className: classes.root,
        // onMouseDown is prefered to onClick for mobile compatibility
        onMouseDown: handleClick,
        onKeyDown: handleKeyPress,
        ref: inputWrapperRef
    };
    const inputProps = {
        className: classes.input,
        placeholder: 'Enter link URL',
        onChange: urlInputChange,
        type: 'text',
        value: value,
        onKeyDown: onLinkInputKeyDown,
        'data-is-notvalid': !validUrl
    };
    return (jsx_runtime_1.jsx("div", Object.assign({}, rootProps, { children: jsx_runtime_1.jsx("input", Object.assign({}, inputProps), void 0) }), void 0));
};
exports.UrlInput = UrlInput;
exports.UrlInput.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    onLinkInputKeyDown: prop_types_1.default.func.isRequired,
    urlInputChange: prop_types_1.default.func.isRequired,
    handleCollapse: prop_types_1.default.func.isRequired,
    value: prop_types_1.default.string.isRequired,
    validUrl: prop_types_1.default.bool.isRequired
};
exports.default = react_jss_1.default(urlInput_style_1.default)(exports.UrlInput);
//# sourceMappingURL=index.js.map